import LifecareStudioSectionCard from './LifecareStudioSectionCard';
import {
  summaryRowClasses,
  summaryTableClasses,
  summaryTotalRowClasses,
  tableBodyCellClasses,
  tableHeadCellClasses,
} from './lifecareStudioClasses';
import { formatCurrency } from '../../utils/lifecarePlanUtils';
import useLifecareStudioSummary from '../../hooks/useLifecareStudioSummary';

const subsectionTitleCellClasses = `${tableBodyCellClasses} text-sm text-content`;

const subtotalCellClasses = `${tableBodyCellClasses} text-right text-sm font-semibold text-content`;

const totalLabelCellClasses = `${tableBodyCellClasses} text-sm uppercase tracking-wider`;

const totalAmountCellClasses = `${tableBodyCellClasses} text-right text-base font-bold text-primary`;

const LifecareStudioSummarySection = ({ order, summaryLines }) => {
  const enrichedLines = useLifecareStudioSummary({ summaryLines });
  return (
    <LifecareStudioSectionCard order={order}>
      <p className="text-xs text-subtle mb-3">
        Subtotals and totals are calculated from the rows above and are not directly editable.
      </p>
      <table className={summaryTableClasses}>
        <thead>
          <tr>
            <th className={tableHeadCellClasses}>Subsection</th>
            <th className={`${tableHeadCellClasses} text-right!`}>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {enrichedLines.map(({ line, index, isTotal }) => (
            <tr key={index} className={isTotal ? summaryTotalRowClasses : summaryRowClasses}>
              <td className={isTotal ? totalLabelCellClasses : subsectionTitleCellClasses}>
                {isTotal ? 'Total Lifetime Care Cost' : line.subsectionTitle || '(untitled)'}
              </td>
              <td className={isTotal ? totalAmountCellClasses : subtotalCellClasses}>
                {formatCurrency(line.subtotal)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </LifecareStudioSectionCard>
  );
};

export default LifecareStudioSummarySection;
